/**
 * Utilità per condivisione e copia link
 */

/**
 * Copia testo negli appunti
 * @param {string} text - Testo da copiare
 * @returns {Promise<boolean>} True se copiato con successo
 */
export function copyToClipboard(text) {
	if (navigator.clipboard && navigator.clipboard.writeText) {
		return navigator.clipboard.writeText(text)
			.then(() => true)
			.catch((error) => {
				console.error('Errore copia negli appunti:', error);
				return false;
			});
	} else {
		// Fallback per browser più vecchi
		const textArea = document.createElement('textarea');
		textArea.value = text;
		textArea.style.position = 'fixed';
		textArea.style.left = '-999999px';
		textArea.style.top = '-999999px';
		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			const successful = document.execCommand('copy');
			document.body.removeChild(textArea);
			return Promise.resolve(successful);
		} catch (error) {
			console.error('Errore copia negli appunti (fallback):', error);
			document.body.removeChild(textArea);
			return Promise.resolve(false);
		}
	}
}

/**
 * Verifica se Web Share API è supportata
 * @returns {boolean}
 */
export function isShareSupported() {
	return typeof navigator !== 'undefined' &&
	       typeof navigator.share === 'function';
}

/**
 * Condivisione nativa usando Web Share API
 * @param {Object} data - Dati da condividere {title, text, url}
 * @returns {Promise<boolean>} True se condiviso con successo
 */
export function shareNative(data) {
	if (!isShareSupported()) {
		return Promise.resolve(false);
	}

	return navigator.share(data)
		.then(() => {
			console.log('Condivisione riuscita');
			return true;
		})
		.catch((error) => {
			// L'utente ha annullato la condivisione o c'è stato un errore
			if (error.name !== 'AbortError') {
				console.error('Errore condivisione:', error);
			}
			return false;
		});
}

/**
 * Condividi o copia link automaticamente
 * Su mobile: usa Web Share API se disponibile
 * Su desktop: copia link negli appunti
 * @param {string} url - URL da condividere/copiare
 * @param {string} title - Titolo per la condivisione (opzionale)
 * @param {string} text - Testo per la condivisione (opzionale)
 * @returns {Promise<{success: boolean, method: 'share'|'copy'}>}
 */
export function shareOrCopy(url, title = 'Sfidami a Tanaca!', text = 'A colpi di libri, film o canzoni di Sanremo. Accetta la sfida!') {
	if (isShareSupported()) {
		// Mobile: usa Web Share API
		return shareNative({ title, text, url })
			.then((success) => ({
				success,
				method: 'share'
			}));
	} else {
		// Desktop: copia negli appunti
		return copyToClipboard(url)
			.then((success) => ({
				success,
				method: 'copy'
			}));
	}
}
